
      // Dynamic import for strict-dynamic CSP compatibility.
      // Retry with backoff if the initial load fails (network blip, CDN delay).
      retryWithBackoff(function() { return import('/src/main.tsx'); }, 3, 1000)(0);
    